import AdvocateSivaPrasadRSDetails from '../../components/about/advocates-details/SivaPrasad_RS';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateSivaPrasadRSDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | Siva Prasad Reddy Singapuram'>
      <NavigationMenu active='about' />
      <PageHeader
        title='Siva Prasad Reddy Singapuram'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateSivaPrasadRSDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateSivaPrasadRSDetailsPage;
